export default {
  methods: {
    reload(destination = undefined, query = {}, params = {}) {
      if (destination === undefined || this.$route.name === destination) {
        // Router won't push to the same location :shrug:
        location.reload();
      } else {
        this.$router.push({ name: destination, query: query, params: params });
      }
    },
  },
};
